import React, { useState, useEffect, useContext } from "react";
import { useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import { Link, useNavigate, useParams } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  Tooltip,
  Button,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import styled from "styled-components";
import Box from "@mui/material/Box";

import FolderIcon from "@mui/icons-material/Folder";
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { ALL_APPLICANT_TERMS_BY_USERUUID_CLIENTID } from "../../graphQL/member";
import { GET_USER_DATA_BY_USERNAME } from "../../graphQL/register_qry";

import MemberAttendanceInfoDialog from "./MemberAttendanceInfoDialog.js";
import ViewNoteDialog from "./ViewNoteDialog";

import AlertDialog from "../../components/AlertDialog.js";
import Header from "./Header.js";

import { project_url } from "../../constants/Data";

const StyledDateTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -45px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const StyledTooltipTerms = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "80px, -20px, 20px, -25px", //-75px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    background: #e2f2ff;
    color: #000;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    display: inline-flex;
    padding: 8px 20px 15px 20px;
    flex-direction: column;
    align-items: center;
  }
`;
const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
  dataGridTyp: {
    fontWeight: 400,
    letterSpacing: "0.01071em !important",
    fontSize: "0.875rem !important",
    // alignItems: "center",
    // justifyContent: "center",
  },
  tooltipStyle: {
    // paddingRight: 15,
    // cursor: "pointer",
    height: 24,
    weight: 24,
    paddingTop: 15,
  },
}));

function MemberTermsList() {
  const navigate = useNavigate();
  const classes = useStyles();
  const client = useContext(ClientContext);
  const [pathname] = useState(window.location.pathname);
  const [memberAttendanceInfo, setMemberAttendanceInfo] = useState(false);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [selectedTermName, setSelectedTermName] = useState("");
  const [selectedTermTeams, setSelectedTermTeams] = useState([]);
  const [selectedTermRoles, setSelectedTermRoles] = useState([]);
  const [selectedTermCompleted, setSelectedTermCompleted] = useState([]);
  const [selectedApplyNextTerm, setSelectedApplyNextTerm] = useState([]);
  const [selectedNote, setSelectedNote] = useState([]);
  const [selectedNoteUpdateBy, setSelectedNoteUpdateBy] = useState([]);
  const [selectedNoteUpdateDate, setSelectedNoteUpdateDate] = useState([]);
  const [teamTermMemberIds, setTeamTermMemberIds] = useState([]);
  const [openViewNoteDialog, setOpenViewNoteDialog] = useState(false);
  const { userUuid } = useParams();

  const [rows, setRows] = useState([]);
  const [fullName, setFullName] = useState([]);
  const [loadContent, setLoadContent] = useState(false);
  const [termsAccess, setTermsAccess] = useState(true);

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const [getAllApplicantTermsQuery] = useManualQuery(ALL_APPLICANT_TERMS_BY_USERUUID_CLIENTID);
  const [getUserDataByUserName] = useManualQuery(GET_USER_DATA_BY_USERNAME);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Members",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let additionalActions = accessData.staffModuleAccess.additionalActions.split('|');
      
      
      if(additionalActions.find(a => a == "Terms")){
        setTermsAccess(true);}
      else setTermsAccess(false);

      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);



  const getMemberTermsList = async () => {
    const {
      loading: loadingData,
      error: errorData,
      data: dataList,
    } = await getAllApplicantTermsQuery({
      variables: {
        userUuid: userUuid,
        clientId: parseInt(clientId),
      },
    });
    if (!loadingData && dataList && dataList.getAllTermApplicantsByuserUuidClientId) {
      let termRowMap = new Map();
      for (var i in dataList.getAllTermApplicantsByuserUuidClientId) {
        let currTermApplicant = dataList.getAllTermApplicantsByuserUuidClientId[i];
        let currTerm = currTermApplicant.termId;
        let currTermId = parseInt(currTerm.termId);
        let teamTermMembers = currTermApplicant.teamTermMember || [];

        if (!termRowMap.has(currTermId)) {
          let data = {};
          data["termId"] = currTermId;
          data["termName"] = currTerm.name;
          data["termUuid"] = currTerm.termUuid;
          data["startDate"] = currTerm.startDate ? dayFormat(currTerm.startDate) : "";
          data["endDate"] = currTerm.endDate ? dayFormat(currTerm.endDate) : "";
          data["teamTermMemberId"] = [];
          data["teamUuid"] = "";
          data["teamName"] = [];
          data["teamRole"] = [];
          data["completed"] = [];
          data["applyNextTerm"] = [];
          data["note"] = [];
          data["noteUpdateBy"] = [];
          data["noteUpdateDate"] = [];
          termRowMap.set(currTermId, data);
        }

        let currTermRow = termRowMap.get(currTermId);
        teamTermMembers.forEach(member => {
          currTermRow.teamTermMemberId.push(member.teamTermMemberId);
          currTermRow.teamUuid = member.teamTermId.teamId.teamUuid;
          currTermRow.teamName.push(member.teamTermId.teamId.name);
          currTermRow.teamRole.push(member.roleId.roleName);
          currTermRow.completed.push(member.completed);
          currTermRow.applyNextTerm.push(member.applyNextTerm);
          currTermRow.note.push(member.note);
          currTermRow.noteUpdateBy.push(member.noteUpdateBy);
          currTermRow.noteUpdateDate.push(member.noteUpdateDate);
        });
      }

      let tmp = [];
      termRowMap.forEach(data => {
        data["isUnassigned"] = data.teamTermMemberId.length === 0;
        tmp.push(data);
      });
      setRows(tmp);
    }
    if (errorData) {
      if (errorData.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
    }

    // Get user information
    const {
      loading: userDataLoading,
      error: userDataError,
      data: userData,
    } = await getUserDataByUserName({
      variables: { username: userUuid },
    });
    if (!userDataLoading && userData && userData.getUserDataByUsername) {
      setFullName(
        userData.getUserDataByUsername.firstName +
          " " +
          userData.getUserDataByUsername.lastName
      );
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getMemberTermsList())();
  }, [userUuid]);

  const columns = [
    {
      field: "termName",
      headerName: "Term Name",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "teamName",
      headerName: "Team",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      colSpan: (...args) => {
        const row = args[0] && args[0].row ? args[0].row : args[1];
        return row && row.isUnassigned === true ? 4 : 1;
      },
      renderCell: rows => {
        if (rows.row.isUnassigned === true) {
          return (
            <Box
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                className={classes.dataGridTyp}
                style={{ fontStyle: "italic", color: "#757575" }}
              >
                Member is not assigned to any team
              </Typography>
            </Box>
          );
        }
        // return rows.row.teamName.map(data => (
        //   <Typography style={{ fontSize: "0.888rem", fontWeight: 500 }}>
        //     {data}
        //   </Typography>
        // ));
        return (
          <Box
            // pt={1}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {rows.row.teamName.map(data => (
              <Typography className={classes.dataGridTyp}> {data} </Typography>
            ))}
          </Box>
        );
      },
    },
    {
      field: "teamRole",
      headerName: "Role",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,

      renderCell: rows => {
        return (
          <Box
            // pt={1}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {rows.row.teamRole.map(data => (
              <Typography className={classes.dataGridTyp}> {data} </Typography>
            ))}
          </Box>
        );
      },
    },
    {
      field: "completed",
      headerName: "Completed?",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,

      renderCell: rows => {
        return (
          <Box
            // pt={1}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {rows.row.completed.map(data => (
              <Typography className={classes.dataGridTyp}> {data ? "Yes" : "No"} </Typography>
            ))}
          </Box>
        );
      },
    },
    {
      field: "applyNextTerm",
      headerName: "Apply Next Term?",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,

      renderCell: rows => {
        return (
          <Box
            // pt={1}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {rows.row.applyNextTerm.map(data => (
              <Typography className={classes.dataGridTyp}> {data ? "Yes" : "No"} </Typography>
            ))}
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 240,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        const isUnassigned = rows.row.isUnassigned;
        return (
          <Box
            // pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="View Attendance">
              <span>
                <IconButton
                  className={classes.tooltipStyle}
                  disabled={isUnassigned}
                >
                  <HowToRegOutlinedIcon
                    onClick={() => {
                      if (isUnassigned) return;
                      setMemberAttendanceInfo(true);
                      setSelectedTerm(rows.row.termUuid);
                      setSelectedTermName(rows.row.termName);
                      setSelectedTermTeams(rows.row.teamName);
                      setSelectedTermRoles(rows.row.teamRole);
                      setTeamTermMemberIds(rows.row.teamTermMemberId);}}
                  />
                </IconButton>
              </span>
            </StyledTooltip>
            <StyledTooltip title="View Notes">
              <span>
                <IconButton 
                  className={classes.tooltipStyle} 
                  style={{ cursor: isUnassigned ? "default" : "pointer" }}
                  disabled={isUnassigned}
                >
                  <EditNoteOutlinedIcon                      
                    onClick={() => {
                      if (isUnassigned) return;
                      setOpenViewNoteDialog(true);
                      setSelectedTerm(rows.row.termUuid);
                      setSelectedTermName(rows.row.termName);
                      setSelectedTermTeams(rows.row.teamName);
                      setSelectedTermRoles(rows.row.teamRole);
                      setSelectedTermCompleted(rows.row.completed);
                      setSelectedApplyNextTerm(rows.row.applyNextTerm);
                      setSelectedNote(rows.row.note);
                      setSelectedNoteUpdateBy(rows.row.noteUpdateBy);
                      setSelectedNoteUpdateDate(rows.row.noteUpdateDate);
                      setTeamTermMemberIds(rows.row.teamTermMemberId);
                    }}
                  />
                </IconButton>
              </span>
            </StyledTooltip>            
          </Box>
        );
      },
    },
  ];

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 15, //5,
            paddingBottom: 15, //6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20 }}>
              Member Terms List
            </Typography>
          </Grid>
          {/* <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              onClick={() => navigate(`${project_url}/users/add`)}
            >
              Add
            </Button>
          </Grid> */}
        </Grid>
        <Divider />
      </>
    );
  }
  if (loadContent)
    if (termsAccess)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: fullName, link: null },
            { label: "Terms List", link: null },
          ]}
        />
        <div className={classes.container}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            // hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.termId}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
              //   sorting: {
              //     sortModel: [{ field: "dateUpdated", sort: "desc" }],
              //   },
            }}
            pageSizeOptions={[10, 25, 50]}
            getRowHeight={() => "auto"}
            sx={{
              "& .MuiDataGrid-cell": {
                alignContent: "center",
                paddingTop: 1,
                paddingBottom: 1,
              },
            }}
          />
          {memberAttendanceInfo && (
            <MemberAttendanceInfoDialog
              closeDialog={() => {
                setMemberAttendanceInfo(false);
              }}
              fullName={fullName}
              userUuid={userUuid}
              termUuid={selectedTerm}
              termName={selectedTermName}
              termTeams={selectedTermTeams}
              termRoles={selectedTermRoles}
              teamTermMemberIds={teamTermMemberIds}
            />
          )}
          {openViewNoteDialog && (
            <ViewNoteDialog
              closeDialog={() => {
                setOpenViewNoteDialog(false);
              }}
              fullName={fullName}
              userUuid={userUuid}
              termUuid={selectedTerm}
              termName={selectedTermName}
              termTeams={selectedTermTeams}
              termRoles={selectedTermRoles}
              completed={selectedTermCompleted}
              applyNextTerm={selectedApplyNextTerm}
              note={selectedNote}
              noteUpdateBy={selectedNoteUpdateBy}
              noteUpdateDate={selectedNoteUpdateDate}
              teamTermMemberIds={teamTermMemberIds}
            />
          )}          
        </div>
      </div>
    );
    else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default MemberTermsList;
